<div class="w-full overflow-x-hidden px-2 py-3 sm:px-4 sm:py-5 lg:px-6">
      <!-- Conditional rendering for each tab component -->
      <app-dashboard *ngIf="isActiveTab('dashboard')"></app-dashboard>
      <app-projects *ngIf="isActiveTab('projects')"></app-projects>
      <app-units *ngIf="isActiveTab('units')"></app-units>
      <app-create-unit *ngIf="isActiveTab('create-unit')"></app-create-unit>
      <app-sales *ngIf="isActiveTab('sales')"></app-sales>
      <ng-container *ngIf="isActiveTab('offers') && offersComponent"
            [ngComponentOutlet]="offersComponent"></ng-container>
      <app-marketing *ngIf="isActiveTab('marketing')"></app-marketing>
      <app-reservations *ngIf="isActiveTab('reservations')"></app-reservations>
      <app-contracts *ngIf="isActiveTab('contracts')"></app-contracts>
      <app-installments *ngIf="isActiveTab('installments')"></app-installments>
      <app-deliveries *ngIf="isActiveTab('deliveries')"></app-deliveries>
      <app-crm-management *ngIf="isActiveTab('crm-management')"></app-crm-management>
      <app-customer-service *ngIf="isActiveTab('customer-service')"></app-customer-service>
      <app-erp *ngIf="isActiveTab('erp')"></app-erp>
      <ng-container *ngIf="isActiveTab('staff') && staffComponent" [ngComponentOutlet]="staffComponent"></ng-container>
      <app-reports *ngIf="isActiveTab('reports')"></app-reports>
      <app-settings *ngIf="isActiveTab('settings')"></app-settings>
      <app-manage-tickets *ngIf="isActiveTab('tickets')"></app-manage-tickets>
</div>
